import { Flex, LoadingSpin, PageContainer } from '@/components/common';
import { SurveyApiType } from '@/configs';
import { Alert } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSurvey } from '@/hooks/app';
import SurveysList from '@/components/survey/SurveysList';

export const SportCapabilities = () => {

  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading } = useSurvey();
  const type = SurveyApiType.SportsCapabilities;

  useEffect(() => {
    fetchSurvey();
  }, []);

  const sportCapabilitiesSurveys = surveys?.filter((survey) => survey.type === type) ?? [];
  const hasSportCapabilities = sportCapabilitiesSurveys.length > 0;

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (!hasSportCapabilities) {
    return (
      <PageContainer title={t(`common:labels.survey-${type}`)}>
        <Alert type="warning" className="flex mx-auto max-h-16 mt-2 text-center" message={t(`common:messages.survey-empty-${type}`)} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t(`common:labels.survey-${type}`)}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={sportCapabilitiesSurveys}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );
};

export default SportCapabilities;
